import React from 'react';
import wheel1 from '../../../assets/images/wheel1.png';
import wheel2 from '../../../assets/images/wheel2.png';
import wheel3 from '../../../assets/images/wheel3.png';
import prizeImg from '../../../assets/images/prize-img.png';
import gameBg from '../../../assets/images/game-bg.png';
import loadingBg from '../../../assets/images/loading-bg.png';
import betBubbleImg from '../../../assets/images/bet-bubble-img.png';
import betBubbleImgActive from '../../../assets/images/bet-bubble-img-active.png';
import oddImg from '../../../assets/images/coef-img.png';
import oddImgMobile from '../../../assets/images/coef-img-mobile.png';
import reBetImg from '../../../assets/images/rebet-img-hover.png';
import betImg from '../../../assets/images/bet-img-hover.png';
import { gameStore } from '../../../store';

const fakeRenderImages = [
  wheel1,
  wheel2,
  wheel3,
  prizeImg,
  gameBg,
  loadingBg,
  betBubbleImg,
  betBubbleImgActive,
  oddImg,
  oddImgMobile,
  reBetImg,
  betImg,
];

export const FakeImagesRender = () => {
  let count = 0;
  return (
    <>
      <div className='fake-render-images-container' style={{ display: 'none' }}>
        {fakeRenderImages?.map((item) => {
          return (
            <img
              src={item}
              alt=''
              style={{ display: 'none' }}
              onLoad={() => {
                gameStore.updateIsFakeImagesLoaded(++count, fakeRenderImages?.length);
              }}
              key={item}
            />
          );
        })}
      </div>
    </>
  );
};
